import React, { useState, useMemo, useCallback, useEffect } from 'react';
import { OntotisDropDown, Person } from '../../../utils/types';
import { CONFIG } from '../../../utils/config';
import { useNavigate, useLocation } from 'react-router-dom';
import { getOntotisDropDown } from '../../../utils/apicall/commonApi';

interface PersonListProps {
  data: Person[];
  from?:string;
  fromid?:string;
  canedit?:boolean;
}

const PersonList: React.FC<PersonListProps> = ({ data, from, fromid, canedit }) => {
  const navigate = useNavigate();
  const [sortConfig, setSortConfig] = useState<{ key: string; direction: 'ascending' | 'descending' } | null>(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedPerson, setSelectedPerson] = useState<Person | null>(null);
  const [ontotisDropDown, setOntotisDropDown] = useState<OntotisDropDown[]>([]);
  const location = useLocation();

  const handleEditClick = (id: any)  => {
    if (from=='ontotis'){
      navigate(CONFIG.urls.getPersonsEditUrl_Admin(id!), {
        state: { returnTo: -1 },
      });
   
    }else{
      navigate(CONFIG.urls.getPersonsEditUrl_Admin(id!), {
        state: { returnTo: CONFIG.urls.getPersonsUrl_Admin() },
      });
    }
  
  };



  const handleViewClick = (person: Person) => {
    setSelectedPerson(person);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedPerson(null);
  };





  // Sort logic
  const sortedData = useMemo(() => {
    let sortableData = [...data];
    if (sortConfig !== null) {
      sortableData.sort((a, b) => {
        let aValue: any;
        let bValue: any;

        switch (sortConfig.key) {
          case 'firstName':
            aValue = a.firstName?.trim().toLowerCase() ?? '';
            bValue = b.firstName?.trim().toLowerCase() ?? '';
            break;
          case 'lastName':
            aValue = a.lastName?.trim().toLowerCase() ?? '';
            bValue = b.lastName?.trim().toLowerCase() ?? '';
            break;
          case 'positions':
            aValue = a.positions.map((position) => position.title).join(', ').toLowerCase();
            bValue = b.positions.map((position) => position.title).join(', ').toLowerCase();
            break;
          case 'phone1':
            aValue = a.phone1;
            bValue = b.phone1;
            break;
          case 'email1':
            aValue = a.email1.toLowerCase();
            bValue = b.email1.toLowerCase();
            break;
          default:
            return 0;
        }

        if (aValue < bValue) return sortConfig.direction === 'ascending' ? -1 : 1;
        if (aValue > bValue) return sortConfig.direction === 'ascending' ? 1 : -1;
        return 0;
      });
    }
    return sortableData;
  }, [data, sortConfig]);

  const requestSort = (key: 'firstName' | 'lastName' | 'positions' | 'phone1' | 'email1') => {
    let direction: 'ascending' | 'descending' = 'ascending';
    if (sortConfig && sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  const getOntotisTitle = (ontoti_id: number) => {
    const ontotis = ontotisDropDown.find((item) => item.id === ontoti_id);
    return ontotis ? ontotis.title : 'Unknown';
  };
  // Load options for "Οντότητα" dropdown
  const loadOntotisDropDown = useCallback(async () => {
    try {
      const response = await getOntotisDropDown();
      if (response) {
        setOntotisDropDown(response);
      } else {
        console.warn('Expected an array but got:', response);
      }
    } catch (error) {
      
    }
  }, []);

 

  useEffect(() => {

    loadOntotisDropDown();
    
  }, [ loadOntotisDropDown]);


  
  return (
    
    <div >
      
      <div className="p-3 bg-white rounded-2 border border-1 table-responsive">
        <table className="table w-100 m-0 table-borderless table table-striped" >
          <thead>
            <tr>
              <th className="sortable" onClick={() => requestSort('lastName')}>
                Επώνυμο <i className="bi bi-arrow-down-up text-muted ms-1"></i>
              </th>
              <th className="sortable" onClick={() => requestSort('firstName')}>
                Όνομα <i className="bi bi-arrow-down-up text-muted ms-1"></i>
              </th>
              <th className="sortable" onClick={() => requestSort('phone1')}>
                Τηλέφωνο <i className="bi bi-arrow-down-up text-muted ms-1"></i>
              </th>
              <th className="sortable" onClick={() => requestSort('email1')}>
                email <i className="bi bi-arrow-down-up text-muted ms-1"></i>
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {sortedData.map((item) => (
              <tr key={item.id}>
                <td><a onClick={() => handleViewClick(item)}  style={{ textDecoration: "none" }}>
                  {item.lastName}
                </a></td>
                <td><a onClick={() => handleViewClick(item)}  style={{ textDecoration: "none" }}>
                  {item.firstName}
                </a></td>
                <td>
                  <span className="ms-3">
                    <a className="dphone text-decoration-none" href={`tel:${item.phone1}`}>
                      {item.phone1}
                    </a>
                  </span>
                </td>
                <td>
                  <span className="ms-3">
                    <a className="dmail text-decoration-none" href={`mailto:${item.email1}`}>
                      {item.email1}
                    </a>
                  </span>
                </td>
           
                <td className="text-end">
                  <button onClick={() => handleViewClick(item)} className="btn btn-secondary btn-sm">
                    <i className="bi bi-eye me-1"></i> Προβολή
                  </button>
                  {((canedit !== undefined && canedit === true) || 
  (item?.can_edit !== undefined && item.can_edit === true)) && (
                       <button className="btn btn-warning btn-sm ms-2"  onClick={() => handleEditClick(item.id!)}>
                       <i className="bi bi-pencil me-1"></i> Επεξεργασία
                       </button>
                    )}
                   
                 {/*<a href={CONFIG.urls.getPersonsEditUrl_Admin(item.id!)} className="btn btn-warning btn-sm ms-2">
                    <i className="bi bi-pencil me-1"></i> Επεξεργασία {JSON.stringify(item, null, 2)}}
            </a>*/}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        
        {/* Modal */}
        {showModal && selectedPerson && (

  <div className="modal show d-block" tabIndex={-1}>
    <div className="modal-dialog">
      <div className="modal-content">
        <div className="modal-header">
          <h1 className="modal-title fs-5" id="personViewModalLabel">
            {selectedPerson.lastName || ''} {selectedPerson.firstName || ''}
          </h1>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={closeModal}
          ></button>
        </div>
        <div className="modal-body bg-light">
          <ul className="list-group list-group-flush">
            <li className="list-group-item d-flex align-items-center rounded-top-3 bg-primary">
              <span className="text-white" style={{ fontSize: '17px' }}>
                Στοιχεία προσώπου
              </span>
            </li>
            <li className="list-group-item d-flex align-items-center">
              <i className="bi bi-geo-alt-fill" style={{ fontSize: '1.5rem', color: '#036EC5' }}></i>
              <span className="ms-3">
                {selectedPerson.address || ''}, {selectedPerson.city || ''}, {selectedPerson.postalCode || ''}
              </span>
            </li>
     

              <li className="list-group-item d-flex align-items-center">
                  {selectedPerson.positions && selectedPerson.positions.length > 0 ? (
                    <>
                      <i className="bi bi-person-fill" style={{ fontSize: '1.5rem', color: '#036EC5' }}></i>
                      <span className="ms-3">
                        
                        {selectedPerson.positions.map((position, index) => (
                          <React.Fragment key={position.id}>
                         
                              <b>{position.title}</b> ({getOntotisTitle(position.pivot.ontoti_id)})
                          
                            {index < selectedPerson.positions.length - 1 && <br />}
                          </React.Fragment>
                        ))}
                      </span>
                    </>
                  ) : (
                    <> <i className="bi bi-person-fill" style={{ fontSize: '1.5rem', color: '#036EC5' }}></i>
                      <span className="ms-3"></span>
                      <b>{selectedPerson.position_title || ''}</b>
                      </>
                  )}
                </li>
            <li className="list-group-item d-flex align-items-center">
              <i className="bi bi-phone-fill" style={{ fontSize: '1.5rem', color: '#036EC5' }}></i>
              <span className="ms-3">
                 {selectedPerson.phone1 || ''}, {selectedPerson.phone2 || ''}
              </span>
            </li>
            <li className="list-group-item d-flex align-items-center">
              <i className="bi bi-envelope-check-fill" style={{ fontSize: '1.5rem', color: '#036EC5' }}></i>
              <span className="ms-3">
                {selectedPerson.email1 || ''}, {selectedPerson.email2 || ''}
              </span>
            </li>
          </ul>
        </div>
        <div className="modal-footer bg-light">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={closeModal}
          >
            <i className="bi bi-file-earmark-spreadsheet"></i>Έξοδος
          </button>
          {(
  (selectedPerson?.can_edit !== undefined && selectedPerson.can_edit === true)) && (
          <button className="btn btn-warning"  onClick={() => handleEditClick(selectedPerson.id!)}>
                  <i className="bi bi-file-earmark-spreadsheet"></i> Επεξεργασία
                  </button>
  )}
          {/*<a className="btn btn-warning" href={CONFIG.urls.getPersonsEditUrl_Admin(selectedPerson.id!)}>
            <i className="bi bi-file-earmark-spreadsheet"></i> Επεξεργασία
                  </a>*/}
        </div>
      </div>
    </div>
  </div>
        )}
      </div>
    </div>
  );
};

export default PersonList;
